export const saveGameDetails = (data: GameDetails): void => {
  localStorage.setItem('gameDetails', JSON.stringify(data));
};

export const getGameDetails = (): GameDetails => {
  const data = localStorage.getItem('gameDetails');
  return data ? JSON.parse(data) : null;
};

export const getGameNextRoundNo = (dataRequest) => {
  const data = localStorage.getItem(dataRequest.gameType);
  if (data) {
    const { gameId, roundTrip, gameType } = JSON.parse(data);
    if (gameId === dataRequest.gameId && roundTrip) return roundTrip;
    if (gameId !== dataRequest.gameId) {
      localStorage.setItem(
        gameType,
        JSON.stringify({ gameId, roundTrip: 1, gameType })
      );
      return 1;
    }
  }
  if (!data) {
    localStorage.setItem(
      dataRequest.gameType,
      JSON.stringify({
        gameId: dataRequest.gameId,
        roundTrip: 1,
        gameType: dataRequest.gameType,
      })
    );
    return 1;
  }
};

export const getPreviousRoundNo = ({
  gameType,
  gameId,
}: {
  gameType: string;
  gameId: string;
}) => {
  const data = localStorage.getItem(gameType);
  if (data) {
    const { gameId, roundTrip, gameType } = JSON.parse(data);
    if (gameId === gameId) {
      return roundTrip === 1 ? 1 : roundTrip - 1;
    }
    if (gameId !== gameId) {
      localStorage.setItem(
        gameType,
        JSON.stringify({ gameId, roundTrip: 1, gameType })
      );
      return 1;
    }
  }
  if (!data) {
    localStorage.setItem(
      gameType,
      JSON.stringify({ gameId, roundTrip: 1, gameType })
    );
    return 1;
  }
};

export const saveGameRoundNo = (data: {
  gameType: string;
  gameId: string;
  roundTrip: number;
}) => {
  if (!data.roundTrip) return;
  localStorage.setItem(data.gameType, JSON.stringify(data));
};
export const deleteGameRound = (gameTypeInput: string) => {
  if (gameTypeInput) {
    const data = localStorage.getItem(gameTypeInput);

    if (data) {
      const { gameType } = JSON.parse(data);
      if (gameType === gameTypeInput) localStorage.removeItem(gameType);
    }
  }
  return;
};
export const getSubscriber = () => {
  const user = localStorage.getItem('user');
  if (user) {
    const userData = JSON.parse(user);
    return userData;
  }
  return null;
};

export const logout = () => {
  localStorage.removeItem('gameDetails');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('user');
  localStorage.removeItem('permissions');
};
